import React from 'react'
import media from '../../../media';

const EditableImage = ({ url, onChange, error, required }) => {
    return (
        <>
            <div className="user_image">
                <div
                    className="image-input image-input-outline"
                    id="kt_image_1"
                >
                    {/* {required && <span style={{ color: "red" }}>*</span>} */}
                    <div
                        className={
                            error
                                ? "image-input-wrapper invalid"
                                : "image-input-wrapper"
                        }
                    >
                        <img
                            src={url || media.Default}
                            alt="img"
                        />
                    </div>

                    <label
                        className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                        data-action="change"
                        data-toggle="tooltip"
                        title=""
                        data-original-title="Change avatar"
                    >
                        <i className="flaticon-edit icon-sm"></i>
                        <input
                            type="file"
                            name="profile_avatar"
                            accept=".png, .jpg, .jpeg"
                            onChange={onChange}
                        />
                        <input
                            type="hidden"
                            name="profile_avatar_remove"
                        />
                    </label>

                    <span
                        className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                        data-action="cancel"
                        data-toggle="tooltip"
                        title="Cancel avatar"
                    >
                        <i className="ki ki-bold-close icon-xs text-muted"></i>
                    </span>
                </div>
            </div>
            <small className="text-danger text-center w-100 d-block">
                {error}
            </small>
        </>
    )
}

export default EditableImage;